module.exports = __webpack_public_path__ + "img/doc.23453410.svg";